import { Layout, Menu } from "antd";
import "./App.scss";
import { useNavigate, useLocation } from "react-router-dom";

interface ISidebar {
  collapsed: boolean;
  setCollapsed: (state: boolean) => void;
}

const Sidebar = ({ collapsed, setCollapsed }: ISidebar) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location", location);

  const routes: any = [
    {
      label: "Логгер",
      key: "/logger",
    },
    {
      label: "Moodle",
      key: "/moodle",
    },
    {
      label: "KoteachVirtual",
      key: "/koteachvirtual",
    },
  ];

  return (
    <Layout.Sider
      className="sidebar"
      breakpoint="lg"
      collapsedWidth={window.screen.width < 450 ? 0 : undefined}
      collapsible={window.innerWidth > 450 ? true : false}
      width={window.innerWidth > 1400 || window.innerWidth < 450 ? 300 : 200}
      collapsed={collapsed}
      onCollapse={() => setCollapsed(!collapsed)}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        // position: "absolute",
        top: 0,
        left: 0,
        zIndex: 999,
      }}
    >
      <div className="sidebar__heading">
        <img
          alt="logo"
          className="sidebar__heading__image"
          src={require("./0.png")}
        />
        {!collapsed && <div style={{ marginLeft: 10 }}>KOTEACH</div>}
      </div>
      <Menu
        theme="dark"
        defaultSelectedKeys={["/logger"]}
        selectedKeys={[location.pathname]}
        mode="inline"
        className="sidebar__menu"
        items={routes.map((route: any) => {
          return {
            label: route.label,
            key: route.key,
            //icon: (<HomeFilled className="sidebar__menu-icon" />),
            onClick: () => {
              navigate(route.key);
              if (window.screen.width < 450) {
                setCollapsed(true);
              }
            },
          };
        })}
      />
    </Layout.Sider>
  );
};

export default Sidebar;
